﻿import {FormattableString, HttpClientError, isNullOrEmpty} from "@2d-front-monorepo/core";
import {MvvmErrorCollector, showErrorDialog, useMvvmContext} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useEffect} from "react";

interface PermitsMvvmErrorCollectorProps {
	title?: FormattableString;
	captureErrors?: boolean;
}

const DEFAULT_TITLE: FormattableString = {text: PermitTranslations.form_error__title};

export default function PermitsMvvmErrorCollector(props: PermitsMvvmErrorCollectorProps): JSX.Element {
	const {title = DEFAULT_TITLE, captureErrors} = props;

	const context = useMvvmContext<any>();
	const exception = context.hasExceptions() ? context.getExceptions()[0] : undefined;

	const shouldShowDialog = exception instanceof HttpClientError && !isNullOrEmpty(exception.problemDetails["is-exception"] as string);

	useEffect(() => {
		if (shouldShowDialog) {
			showErrorDialog(exception);
		}
	}, [shouldShowDialog, exception]);

	if (shouldShowDialog) return <></>;

	return <MvvmErrorCollector title={title} debug={false} captureErrors={captureErrors}/>;
}
